import { EvaluationINV1 } from './Inventory'

class DataCsvInventory {
	public requester: string
	public email_requester: string
	public identificationOffline: string
	public identifier: string
	public category_tree: number
	public userId: string
	public species: any
	public lat?: number
	public lng?: number
	public address: string
	public locationReference: string
	public company: string
	public media_url: Array<string> = []
	public media_url_inventory: Array<string> = []
	public characterization: {
		fuste: {
			type: string
			value: number
		}
		dap_cap: {
			type: string
			average: number
		}
		characterization_code: number
		height: number
		cup_projection: number
		specialValue: boolean
	}
	public inventorAnswers: EvaluationINV1
	public handlerOperations: Array<{
		handlerOperation: string
	}>
	public create_date: Date
	public observation: string
	public line: number
}


class objectWithPositionFieldReportInventory {
	public requester?: string
	public requester_email?: string
	public identifier?: string
	public address?: string
	public lat?: string
	public lng?: string
	public media_url?: string
	public company?: string
	public species?: string
	public characterization_code?: string
	public height?: string
	public fuste?: string
	public category_tree?: number
	public cup_projection?: string
	public dap_cap_type?: string
	public dap_cap_value?: string
	public specialValue?: string
	public managmentTree?: string
}

class Company {
	public _id: string
	public address: string
	public social_name: string
}


class Alternatives {
	public photoUrl: string
		public alternatives: [{
				text: string
		}]
}

export {DataCsvInventory, objectWithPositionFieldReportInventory, Company}
